<template>
    <b-modal
        id="error-modal-id"
        no-close-on-backdrop
        no-close-on-esc
        hide-header
        hide-footer
        centered
        v-model="modalShow"
    >
        <div class="d-flex flex-column align-items-center justify-center-center my-2">
            <feather-icon
                id="view-modal-error-id"
                icon="AlertCircleIcon"
                :class="'text-'+type+ ' mb-2'"
                size="80"
            />
            <div class="text-center">
                <span>{{ infoTextModal }}</span>
            </div>
            <div class="d-flex mt-2">
                <b-button :disabled="loading" :variant="'outline-'+type" @click="confirmAction" >
                    <span v-if="loading" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                        {{ action }}
                </b-button>
            </div>
        </div>
    </b-modal>
</template>

<script>
import { BModal, BButton } from 'bootstrap-vue';
export default {
    components: {
        BModal, BButton
    },

    props: {
        modalShow: {
            required: true,
            type: Boolean
        },
        caseModal: {
            required: true,
            type: String
        },
        infoText: {
            type: String,
            required: false
        }
    },

    data() {
        return {
            loading: false,
            textComplement: '',
            modalTypes: [
                {
                    'type': 'danger',
                    'case': 'idInexistente',
                    'action': 'Ok',
                    'infoText': `Não foi encontrada a entidade selecionada, redirecionando.`
                },
                {
                    'type': 'danger',
                    'case': 'naoInativo',
                    'action': 'Ok',
                    'infoText': `Não foi possível inativar o registro.`
                },
                {
                    'type': 'danger',
                    'case': 'selecaoInvalida',
                    'action': 'Ok',
                    'infoText': `A seleção não é mais válida, faça uma nova seleção.`
                },
                {
                  'type': 'danger',
                  'case': 'erroAoDesvincular',
                  'action': 'Ok',
                  'infoText': `Não foi possível desvincular, pois existem colaboradores com registros de vacinação.`
                },
            ],
            type: '',
            case: '',
            action: '',
            infoTextModal: ''
        }
    },

    methods: {
        confirmAction(modalEvent) {
            modalEvent.preventDefault();

            this.loading = true;

            this.$emit('confirmed', modalEvent);
        }
    },

    watch: {
        modalShow() {
            this.loading = false;
            this.modalTypes.map(item => {
                if(item.case == this.$props.caseModal) {
                    this.action = item.action;
                    this.case = item.case;
                    this.infoTextModal = this.$props.infoText ? this.$props.infoText : item.infoText;
                    this.type = item.type;
                }
            });
        }
    }
}
</script>
